import { render, staticRenderFns } from "./MultiPosterPage.vue?vue&type=template&id=5c4a11d0&"
import script from "./MultiPosterPage.vue?vue&type=script&lang=js&"
export * from "./MultiPosterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports